<template>
    <div v-bind:style="{ paddingTop:this.spacing}"> </div>
</template>

<script>
    export default {
        data: function () {
            return {
                spacing: this.space ?? '20px'
            }
        },
        props: ['space'],
        name: "SpacerComponent",
        mounted() {
            // console.log(this.space);
        }
    }
</script>

<style scoped>

</style>
